// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import { Image, Carousel, CarouselItem, Dropdown, DropdownMenu, DropdownItem, Pagination } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 国际化
import i18n from './locales'

import '../static/css/app.scss'

Vue.use(Image)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Pagination)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js